export type CustomerProofContent = {
  logos: { name: string; src: string; approvedForPublication: boolean }[];
  testimonials: {
    quote: string;
    name: string;
    role: string;
    approvedForPublication: boolean;
  }[];
};

// Populate with owner-approved real material; generated photos are never evidence of client work.
export const CUSTOMER_PROOF: CustomerProofContent = {
  logos: [],
  testimonials: [],
};

export function CustomerProof({
  content = CUSTOMER_PROOF,
}: {
  content?: CustomerProofContent;
}) {
  const logos = content.logos.filter(
    (item) =>
      item.approvedForPublication &&
      item.name.trim() &&
      item.src.startsWith("/images/"),
  );
  const testimonials = content.testimonials.filter(
    (item) =>
      item.approvedForPublication &&
      item.name.trim() &&
      item.role.trim() &&
      item.quote.trim(),
  );
  if (!logos.length && !testimonials.length) return null;
  return (
    <section
      className="hp-section hp-customer-proof"
      aria-labelledby="hp-proof-title"
    >
      <h2 id="hp-proof-title">לקוחות שבחרו ליצור איתנו</h2>
      {logos.length ? (
        <ul className="hp-client-logos" role="list">
          {logos.map((item) => (
            <li key={item.name}>
              <img
                src={item.src}
                alt={item.name}
                loading="lazy"
                width={160}
                height={80}
              />
            </li>
          ))}
        </ul>
      ) : null}
      {testimonials.length ? (
        <div className="hp-testimonials">
          {testimonials.map((item) => (
            <figure key={`${item.name}-${item.role}`}>
              <blockquote>{item.quote}</blockquote>
              <figcaption>
                <strong>{item.name}</strong>
                <span>{item.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      ) : null}
    </section>
  );
}
